import { Box, Slider } from '@mui/material'
import { FC } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { ColoursObj, Typography } from '@eventr/common-storybook'
import { useEphemeralStore } from '../../../state/useEphemeralStore'

const marks = () => {
    const returnMarks: any[] = []
    for (var index = 1; index < 11; index++) {
        returnMarks.push({
            value: index,
            label: (
                <Typography color={ColoursObj.font.secondary}>
                    {index}
                </Typography>
            ),
        })
    }
    return returnMarks
}

export const GuestReviewsFilter: FC = () => {
    const { filtersObj, setFiltersObj } = useEphemeralStore(
        useShallow((s) => ({
            filtersObj: s.filtersObj,
            setFiltersObj: s.setFiltersObj,
        }))
    )

    return (
        <Box display={'grid'} gap={'8px'}>
            <Typography variant="bodySubtext" color={ColoursObj.font.secondary}>
                User Rating {filtersObj.userRatingRange[0]} {' - '}{' '}
                {filtersObj.userRatingRange[1]} {' / 10'}
            </Typography>

            <Box padding={'0 8px'}>
                <Slider
                    value={filtersObj.userRatingRange}
                    disableSwap
                    valueLabelDisplay="auto"
                    min={1}
                    max={10}
                    marks={marks()}
                    onChange={(event, value, active) => {
                        if (active === 0) {
                            setFiltersObj({
                                ...filtersObj,
                                userRatingRange: [
                                    value[0],
                                    filtersObj.userRatingRange[1],
                                ],
                            })
                        }
                        if (active === 1) {
                            setFiltersObj({
                                ...filtersObj,
                                userRatingRange: [
                                    filtersObj.userRatingRange[0],
                                    value[1],
                                ],
                            })
                        }
                    }}
                    color="secondary"
                />
            </Box>
        </Box>
    )
}
